/**
 * Sync Ant Design ConfigProvider locale with SupportedLocale.
 */

import React, { useMemo } from 'react';
import { ConfigProvider, type ThemeConfig } from 'antd';
import enUS from 'antd/locale/en_US';
import jaJP from 'antd/locale/ja_JP';
import koKR from 'antd/locale/ko_KR';
import type { Locale } from 'antd/es/locale';
import { useLocaleOptionalV0 } from './LocaleProvider';
import type { SupportedLocale } from './localeCanon';

const ANTD_LOCALES: Record<SupportedLocale, Locale> = {
  'ko-KR': koKR,
  en: enUS,
  'ja-JP': jaJP,
};

export interface AntdLocaleBridgeProps {
  children: React.ReactNode;
  theme?: ThemeConfig;
}

export function AntdLocaleBridge({ children, theme }: AntdLocaleBridgeProps): React.ReactElement {
  const { locale } = useLocaleOptionalV0();
  const antdLocale = useMemo(() => ANTD_LOCALES[locale] ?? enUS, [locale]);
  return (
    <ConfigProvider locale={antdLocale} theme={theme}>
      {children}
    </ConfigProvider>
  );
}
